module.exports = __webpack_public_path__ + "img/star_off.5dd2cd15.svg";